<template>
  <div>
    <div class="footer drRtl">
      <!-- 
      <img class="smoke" src="../../assets/images/smoke.gif" alt="">
      <img class="smoke1" src="../../assets/images/smoke1.gif" alt=""> -->

      <div class="footer__box w margin">
        <div v-if="$root.globalData" class="footer__item item1">
          <h1 class="logo">
            <router-link to="/">
              <img
                width="100px"
                :src="
                  'https://gorgon.ir/storage/' +
                  $root.globalData.settings.logo_pages
                "
                alt="logo"
              />
            </router-link>
          </h1>
          <p class="desc" v-if="$root.globalData">
            {{ $root.globalData.keys.footer_text }}
          </p>
          <p class="phone">
            <!-- <span> {{  $root.globalData.settings.footer_phone  }} </span> <TelIcon /> -->
          </p>

          <div class="socials">
            <a :href="$root.globalData.settings.social_telegram">
              <svg
                height="31"
                width="31"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 512 512"
                xml:space="preserve"
              >
                <circle style="fill: #59aae7" cx="256" cy="256" r="256" />
                <path
                  style="fill: #3d9ae3"
                  d="M256,0c-11.317,0-22.461,0.744-33.391,2.167C348.216,18.53,445.217,125.933,445.217,256
	s-97.002,237.47-222.609,253.833C233.539,511.256,244.683,512,256,512c141.385,0,256-114.616,256-256S397.385,0,256,0z"
                />
                <path
                  style="fill: #fcfcfc"
                  d="M164.689,311.141L82.127,269.86c-2.263-1.132-2.285-4.353-0.038-5.516L395.75,102.105
	c2.304-1.192,4.964,0.811,4.456,3.355l-54.004,270.017c-0.385,1.927-2.446,3.011-4.253,2.237l-73.393-31.453
	c-0.879-0.377-1.884-0.326-2.721,0.139l-94.839,52.688c-2.062,1.145-4.597-0.345-4.597-2.705v-82.474
	C166.4,312.736,165.738,311.665,164.689,311.141z"
                />
                <path
                  style="fill: #d8d7da"
                  d="M200.31,338.967l-0.513-82.428c-0.003-0.528,0.27-1.018,0.72-1.293l133.899-81.798
	c1.518-0.927,3.106,1.083,1.852,2.345l-101.9,102.624c-0.112,0.114-0.207,0.244-0.278,0.387l-17.43,34.858l-13.509,25.988
	C202.426,341.045,200.32,340.538,200.31,338.967z"
                />
              </svg>
            </a>
            <a :href="$root.globalData.settings.social_instagram">
              <svg
                width="31"
                height="31"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="28"
                  height="28"
                  rx="6"
                  fill="url(#paint0_radial_87_7153)"
                />
                <rect
                  x="2"
                  y="2"
                  width="28"
                  height="28"
                  rx="6"
                  fill="url(#paint1_radial_87_7153)"
                />
                <rect
                  x="2"
                  y="2"
                  width="28"
                  height="28"
                  rx="6"
                  fill="url(#paint2_radial_87_7153)"
                />
                <path
                  d="M23 10.5C23 11.3284 22.3284 12 21.5 12C20.6716 12 20 11.3284 20 10.5C20 9.67157 20.6716 9 21.5 9C22.3284 9 23 9.67157 23 10.5Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6 15.6C6 12.2397 6 10.5595 6.65396 9.27606C7.2292 8.14708 8.14708 7.2292 9.27606 6.65396C10.5595 6 12.2397 6 15.6 6H16.4C19.7603 6 21.4405 6 22.7239 6.65396C23.8529 7.2292 24.7708 8.14708 25.346 9.27606C26 10.5595 26 12.2397 26 15.6V16.4C26 19.7603 26 21.4405 25.346 22.7239C24.7708 23.8529 23.8529 24.7708 22.7239 25.346C21.4405 26 19.7603 26 16.4 26H15.6C12.2397 26 10.5595 26 9.27606 25.346C8.14708 24.7708 7.2292 23.8529 6.65396 22.7239C6 21.4405 6 19.7603 6 16.4V15.6ZM15.6 8H16.4C18.1132 8 19.2777 8.00156 20.1779 8.0751C21.0548 8.14674 21.5032 8.27659 21.816 8.43597C22.5686 8.81947 23.1805 9.43139 23.564 10.184C23.7234 10.4968 23.8533 10.9452 23.9249 11.8221C23.9984 12.7223 24 13.8868 24 15.6V16.4C24 18.1132 23.9984 19.2777 23.9249 20.1779C23.8533 21.0548 23.7234 21.5032 23.564 21.816C23.1805 22.5686 22.5686 23.1805 21.816 23.564C21.5032 23.7234 21.0548 23.8533 20.1779 23.9249C19.2777 23.9984 18.1132 24 16.4 24H15.6C13.8868 24 12.7223 23.9984 11.8221 23.9249C10.9452 23.8533 10.4968 23.7234 10.184 23.564C9.43139 23.1805 8.81947 22.5686 8.43597 21.816C8.27659 21.5032 8.14674 21.0548 8.0751 20.1779C8.00156 19.2777 8 18.1132 8 16.4V15.6C8 13.8868 8.00156 12.7223 8.0751 11.8221C8.14674 10.9452 8.27659 10.4968 8.43597 10.184C8.81947 9.43139 9.43139 8.81947 10.184 8.43597C10.4968 8.27659 10.9452 8.14674 11.8221 8.0751C12.7223 8.00156 13.8868 8 15.6 8Z"
                  fill="white"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_87_7153"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(12 23) rotate(-55.3758) scale(25.5196)"
                  >
                    <stop stop-color="#B13589" />
                    <stop offset="0.79309" stop-color="#C62F94" />
                    <stop offset="1" stop-color="#8A3AC8" />
                  </radialGradient>
                  <radialGradient
                    id="paint1_radial_87_7153"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(11 31) rotate(-65.1363) scale(22.5942)"
                  >
                    <stop stop-color="#E0E8B7" />
                    <stop offset="0.444662" stop-color="#FB8A2E" />
                    <stop offset="0.71474" stop-color="#E2425C" />
                    <stop offset="1" stop-color="#E2425C" stop-opacity="0" />
                  </radialGradient>
                  <radialGradient
                    id="paint2_radial_87_7153"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(0.500002 3) rotate(-8.1301) scale(38.8909 8.31836)"
                  >
                    <stop offset="0.156701" stop-color="#406ADC" />
                    <stop offset="0.467799" stop-color="#6A45BE" />
                    <stop offset="1" stop-color="#6A45BE" stop-opacity="0" />
                  </radialGradient>
                </defs>
              </svg>
            </a>
            <a :href="$root.globalData.settings.social_whatsapp"
              ><Whatsapp
            /></a>
            <a :href="$root.globalData.settings.social_twitter"><Twitter /></a>
          </div>
        </div>

        <div v-if="$root.globalData" class="footer__item item2">
          <div class="lists">
            <div class="listbox1">
              <ul class="lists">
                <li
                  class="list__item"
                  v-for="(item, index) in $root.globalData.menus.footer"
                  :key="index"
                >
                  <router-link
                    class="responsive__items"
                    v-if="item.linkable_type != null"
                    :to="
                      findUrl(item.linkable_type, item.linkable_id, item.slug)
                    "
                  >
                    {{ item.title }}
                  </router-link>
                  <a v-else class="responsive__items2" :href="item.link">
                    {{ item.title }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- item3 -->
        <div v-if="$root.globalData" class="footer__item item3">
          <p class="logintext">{{ $root.globalData.keys.newsletter_text }}</p>

          <div class="search">
            <form class="formlogin" @submit.prevent="joinNewsletter()">
              <input
                type="text"
                name=""
                id=""
                v-model="newsletter"
                :placeholder="$root.globalData.keys.newsletter_placeholder"
              />
              <input
                type="submit"
                :value="$root.globalData.keys.newsletter_button"
              />
            </form>
          </div>

          <div class="labtop">
            <img :src="labtop" alt="labtop" />
          </div>
        </div>
      </div>
      <div class="copyright w margin">
        <p>{{ copyrightrightbox }}</p>
        <p>
          Copyright 2021 inYab Designed By
          <a href="https://shetabit.com/" target="_blank"> shetabit</a> | All
          rights reserved
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import findUrl from "@/assets/links/LinkResolver.js";

import Logo from "../../assets/images/FooterLogoPng.png";
import TelIcon from "../svgs/TelIcon.vue";
import Telegram from "../svgs/Telegram.vue";
import Instagram from "../svgs/Instagram.vue";
import Whatsapp from "../svgs/Whatsapp.vue";
import Twitter from "../svgs/Twitter.vue";
import Labtop from "../../assets/images/labtopgif.gif";
export default {
  data() {
    return {
      newsletter: "",
      labtop: Labtop,
      logo: Logo,
      item1text:
        " اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و بدون معنی است ",
      phone1: " ۰۹۱۱۴۰۸۸۳۷۶ ",
      phone2: " ۰۹۱۱۴۰۸۸۳۷۶ ",
      listbox1: ["آلمینیوم", "نولیدی ماسک", "آلمینیوم", "لبنیات"],
      listbox2: ["آق قلا", "کردکوی", "علی آباد", "گنبد"],

      item3text:
        "جهت اطلاع از آخرین اخبار و اطلاعیه ها در خبرنامه ما عضو شوید ",

      copyrightrightbox:
        ".کلیه حقوق سایت به inYab  تعلق دارد و کپی برداری از آن ممنوع می باشد ",
    };
  },
  methods: {
    findUrl,
    ValidateEmail(mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true;
      }
      return false;
    },
    joinNewsletter() {
      if (!this.ValidateEmail(this.newsletter)) {
        this.$toast.warning(
          this.$root.globalData
            ? this.$root.globalData.keys
                .please_enter_an_email_in_the_correct_format_text
            : ""
        );
      } else {
        const formData = new FormData();
        formData.append("email", this.newsletter);
        this.newsletter = "";
        this.$axios.post("front/subscribe", formData).then((res) => {
          this.$toast.success(
            this.$root.globalData
              ? this.$root.globalData.keys
                  .not_found_any_blog_for_your_request_text
              : ""
          );
        });
      }
    },
  },
  components: { TelIcon, Telegram, Instagram, Whatsapp, Twitter },
};
</script>

<style scoped>
.footer {
  width: 100%;
  background-image: url(../../assets/images/footerbg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 1rem 0;
  position: relative;
}

.smoke {
  width: 150px;
  position: absolute;
  right: 35.5%;
  top: 23%;
  opacity: 0.2;
  opacity: 0.2;
}
.smoke1 {
  width: 150px;
  position: absolute;
  top: 7%;
  left: 41%;
  opacity: 0.2;
}

.footer__box {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  margin-bottom: 1rem;
  border-bottom: 2px solid #666;
  padding-top: 3rem;
}
@media (max-width: 768px) {
  .footer__box {
    display: flex;
    align-items: center;
    grid-template-columns: unset;
    flex-direction: column-reverse;
  }
}
.footer__item {
  padding: 0 1rem;
  text-align: justify;
}

.item1,
.item2 {
  text-align: right;
}

.item2 {
  margin-right: 1rem;
}
@media (max-width: 768px) {
  .item2 {
    width: 100%;
    margin: 10px 0;
  }
}
.item2 a {
  color: black;
}
.item2 p {
  font-size: 18px;
  font-weight: bold;
}

.item1 {
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
}
.item1 .logo,
.desc,
.phone,
.social {
  margin-bottom: 1rem;
}
.item1 p {
  font-size: 14px;
  line-height: 3;
  text-align: justify;
}

.phone {
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone span {
  font-size: 18px;
  padding: 0 10px;
}
.socials {
  display: flex;
  justify-content: center;
}
.listbox1 {
  display: flex;
  justify-content: space-between;
}
.list__item {
  padding: 10px 0;
  list-style-type: disc;
  font-size: 14px;
}
.item3 {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.logintext {
  font-size: 14px;
  margin-bottom: 2rem;
  font-weight: bold;
}
.search {
  background-color: #c8c8c8;
  border-radius: 30px;
}
.formlogin {
  border-radius: 30px;
  display: flex;
  justify-content: space-between;
  background-color: #9c9c9c91;
  padding: 5px;
}

.formlogin input {
  padding: 10px;
  border-radius: 20px;
}
.formlogin input:first-child {
  display: flex;
  width: 100%;
  background-color: transparent;
  color: #000;
  outline: none;
  flex-wrap: wrap;
}
.formlogin input:last-child {
  background-color: grey;
  color: #fff;
  padding: 10px 30px;
}
.labtop {
  filter: grayscale(10);
}
.labtop img {
  height: 350px;
}
.copyright {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
@media only screen and (max-width: 768px) {
  .labtop {
    display: none;
    justify-content: center;
  }
}
@media only screen and (max-width: 460px) {
  .item3 {
    text-align: center !important;
  }
}
</style>
<style>
.ltrStyle .item1 p,
.ltrStyle .logintext {
  direction: ltr;
}
.ltrStyle .phone {
  justify-content: flex-start;
}
</style>
